// Note: Should be kept in sync with api

export const enum WS_REQUEST {
    // Auth
    auth_logIn = 'auth/logIn',
    // Sync
    sync_clientSync = 'sync/clientSync',
}

export const enum WS_RESPONSE {
    // Generic
    generic = 'response:generic',
    rateLimited = 'response:rateLimited',
    connectedClients = 'response:connectedClients',
    // Auth
    auth_logIn = 'response:auth/logIn',
    // Sync
    sync_clientSync = 'response:sync/clientSync',
    // OpenRouter
    openRouter_prompt = 'response:openRouter/prompt',
}
